import { genericMemo } from "@redotech/react-util/component";
import { ReactElement, ReactNode } from "react";
import { RedoHorizontalTabs } from "./arbiter-components/tabs/redo-horizontal-tabs";
import { Flex } from "./flex";
import { Tabs } from "./tab";

export const RedoHorizontalTabsWithActions = genericMemo(
  function RedoHorizontalTabsWithActions({
    tabs,
    actions,
    stretchTabs = true,
    align = "flex-end",
    justify = "space-between",
  }: {
    tabs: ReactElement;
    actions?: ReactNode;
    stretchTabs?: boolean;
    align?: "flex-start" | "flex-end" | "center";
    justify?: "space-between" | "flex-start" | "flex-end" | "center";
  }) {
    if (!(tabs.type === Tabs || tabs.type === RedoHorizontalTabs)) {
      throw new Error(
        "The tabs prop must be a <Tabs> or <RedoHorizontalTabs> component.",
      );
    }

    return (
      <Flex align={align} dir="row" justify={justify} w="full">
        <Flex flex={stretchTabs ? 1 : undefined}>{tabs}</Flex>
        {actions && <Flex align="center">{actions}</Flex>}
      </Flex>
    );
  },
);
